import { Moment, MomentInput, unitOfTime } from 'moment';

const chunk = (arr: number[], size: number) =>
  arr.reduce(
    (ret, cur) => {
      const top = ret.pop() || [];
      if (top.length >= size) {
        ret.push(top, [cur]);
      } else {
        top.push(cur);
        ret.push(top);
      }
      return ret;
    },
    [] as number[][]
  );

const range = (start: number, end: number): number[] =>
  Array.from({ length: end - start }, (v, i) => i + start);

export const getDays = (moment: Moment): number[][] => {
  const d1 = moment
    .clone()
    .subtract(1, 'month')
    .endOf('month')
    .date();
  const d2 = moment
    .clone()
    .date(1)
    .day();
  const d3 = moment
    .clone()
    .endOf('month')
    .date();
  return chunk(
    [
      ...range(d1 - d2 + 1, d1 + 1),
      ...range(1, d3 + 1),
      ...range(1, 42 - d3 - d2 + 1)
    ],
    7
  );
};

export const cloneMomentByYearAndMonth = (
  moment: Moment,
  year: number,
  month: number
) =>
  moment
    .clone()
    .year(year)
    .month(month);

export const isPrevMonth = (week: number, day: number) => week === 0 && day > 7;

export const isNextMonth = (week: number, day: number) =>
  week >= 4 && day <= 14;

type MomentStatus = 0 | -1 | 1;

export type IsMomentValid = (
  moment: Moment,
  minMoment?: MomentInput,
  maxMoment?: MomentInput,
  limit?: unitOfTime.StartOf
) => MomentStatus;

/**
 * -1: < min
 * 0:  valid
 * 1:  > max
 */
export function isMomentValid(
  moment: Moment,
  minMoment?: MomentInput,
  maxMoment?: MomentInput,
  limit?: unitOfTime.StartOf
): MomentStatus {
  if (!minMoment && !maxMoment) {
    return 0;
  }

  let status: MomentStatus = 0;

  if (minMoment) {
    status = moment.isSameOrAfter(minMoment, limit) ? 0 : -1;
  }
  if (maxMoment) {
    status = moment.isSameOrBefore(maxMoment, limit) ? status : 1;
  }

  return status;
}
